import { ReactComponent as IcAngleRight } from '../../assets/img/ic-angle-right.svg';

// Desktop-only Ask Abroadify card. Presentational: state and submit logic stay
// with the caller (the jobs page keeps its own; other map-first pages use
// the shared assistant state via DiscoveryDesktopAiSlot). Never used by the mobile bottom sheet.
const DiscoveryAiDesktopCard = ({
    aiQuery,
    setAiQuery,
    aiLoading,
    aiResult,
    aiError,
    sourceOptions,
    selectedAiSources,
    toggleAiSource,
    onSubmit,
    onApplyFilters,
    inputRef,
}) => (
    <div className="discovery-ai-card">
        <div className="discovery-ai-card-title">Ask Abroadify</div>

        <div className="discovery-ai-input-row">
            <div className="discovery-ai-input-wrap">
                <input
                    ref={inputRef}
                    type="text"
                    className="form-control discovery-ai-input"
                    placeholder="Can you tell me..."
                    value={aiQuery}
                    disabled={aiLoading}
                    onChange={(e) => setAiQuery(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            onSubmit();
                        }
                    }}
                />

                <button
                    type="button"
                    className="discovery-ai-submit"
                    onClick={onSubmit}
                    disabled={aiLoading}
                    aria-label="Submit Ask Abroadify query"
                >
                    <IcAngleRight className="discovery-ai-submit-icon" />
                </button>
            </div>
        </div>

        <div className="discovery-ai-source-row">
            {sourceOptions.map((source) => {
                const isSelected = selectedAiSources.includes(source.value);
                const isRequired = source.value === 'abroadify';

                return (
                    <button
                        key={source.value}
                        type="button"
                        className={`discovery-ai-source-chip ${isSelected ? 'is-selected' : ''}`}
                        onClick={() => toggleAiSource(source.value)}
                        disabled={isRequired}
                    >
                        {isSelected && <span aria-hidden="true">&#10003; </span>}
                        {source.label}
                    </button>
                );
            })}
        </div>

        {(aiLoading || aiResult || aiError) && (
            <div className="discovery-ai-response">
                <div className="discovery-ai-answer">
                    {aiLoading && <span className="discovery-ai-thinking">Thinking</span>}
                    {!aiLoading && aiError}
                    {!aiLoading && !aiError && aiResult?.answer}
                </div>

                <div className="discovery-ai-sources">
                    {`Using ${selectedAiSources.length} source${selectedAiSources.length > 1 ? 's' : ''}`}
                </div>

                {aiResult?.suggestedFilters?.length > 0 && typeof onApplyFilters === 'function' && (
                    <div className="discovery-ai-filters">
                        <div className="discovery-ai-filter-chips">
                            {aiResult.suggestedFilters.map((filter) => (
                                <button
                                    key={filter}
                                    type="button"
                                    className="discovery-ai-filter-chip"
                                    onClick={() => onApplyFilters(aiResult.structuredFilters)}
                                >
                                    {filter}
                                </button>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        )}
    </div>
);

export default DiscoveryAiDesktopCard;
